var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4C17.3993 4 18.5015 4.4267 19.3141 5.18622C20.1268 5.94574 20.5833 6.97587 20.5833 8.05C20.5833 9.12413 20.1268 10.1543 19.3141 10.9138C18.5015 11.6733 17.3993 12.1 16.25 12.1C15.1007 12.1 13.9985 11.6733 13.1859 10.9138C12.3732 10.1543 11.9167 9.12413 11.9167 8.05C11.9167 6.97587 12.3732 5.94574 13.1859 5.18622C13.9985 4.4267 15.1007 4 16.25 4ZM16.25 5.92375C15.6466 5.92375 15.068 6.14776 14.6413 6.54651C14.2147 6.94526 13.975 7.48608 13.975 8.05C13.975 8.61392 14.2147 9.15474 14.6413 9.55349C15.068 9.95224 15.6466 10.1763 16.25 10.1763C16.8534 10.1763 17.432 9.95224 17.8587 9.55349C18.2853 9.15474 18.525 8.61392 18.525 8.05C18.525 7.48608 18.2853 6.94526 17.8587 6.54651C17.432 6.14776 16.8534 5.92375 16.25 5.92375ZM16.25 13.1125C19.1425 13.1125 24.9167 14.4591 24.9167 17.1625V20.2H7.58334V17.1625C7.58334 14.4591 13.3575 13.1125 16.25 13.1125ZM16.25 15.0363C13 15.0363 9.64168 16.5145 9.64168 17.1625V18.2763H22.8583V17.1625C22.8583 16.5145 19.4675 15.0363 16.25 15.0363ZM5.41668 13.396L2.70834 14.9046L3.44501 12.0595L1.08334 10.156L4.19251 9.90288L5.41668 7.22988L6.61918 9.90288L9.75001 10.156L7.36668 12.0595L8.07084 14.9046L5.41668 13.396Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPerson);
export default __webpack_public_path__ + "static/media/star_person.40ccfc142ad32f881b49c183b0ea5939.svg";
export { ForwardRef as ReactComponent };